import { type RouteRecordRaw } from "vue-router";

import { APP_SETTINGS_ROUTES as SETTINGS } from "@/Generated/Routes/paths";

import help from "./Help";
import questionnaires from "./Questionnaires";
import payments from "./Payments";
import invoices from "./Invoices";
import subscriptions from "./Subscriptions";
import accounts from "./Accounts";
import legalAgreements from "./LegalAgreements";

import { buildBeforeEnterChain, isTherapistGuard } from "@/Router/guards";

export default [
  {
    path: SETTINGS.root.path,
    components: {
      main: () => import("@/Components/layout/BlankLayout.vue"),
      sidebar: () => import("@/Views/settings/Menu.vue"),
    },
    meta: { noHeader: true, sidebar: true, drawer: false },
    children: [
      {
        ...SETTINGS.root,
        component: () => import("@/Views/MainLanding.vue"),
      },
      ...accounts,
      {
        ...SETTINGS.configuration.root,
        component: () => import("@/Views/settings/configuration/index.vue"),
        meta: {
          sidebar: false,
          i18nTitle: "settings.configuration.title",
        },
      },
      ...invoices,
      ...payments,
      ...subscriptions,
      {
        ...SETTINGS.loyaltyPlan.root,
        component: () => import("@/Views/settings/loyaltyPlan/index.vue"),
        meta: {
          sidebar: false,
          i18nTitle: "settings.loyalty_plan",
        },
        beforeEnter: buildBeforeEnterChain(isTherapistGuard),
      },
      {
        ...SETTINGS.timeZone.root,
        component: () => import("@/Views/settings/timeZone/index.vue"),
        meta: {
          sidebar: false,
          i18nTitle: "settings.configuration.time_zone.title",
        },
      },
      ...questionnaires,
      {
        ...SETTINGS.patientReferral.root,
        component: () => import("@/Views/settings/patientReferral/index.vue"),
        meta: {
          sidebar: false,
          i18nTitle: "settings.patient_referral-title",
        },
      },
      ...legalAgreements,
      {
        ...SETTINGS.privacy.root,
        component: () => import("@/Views/settings/privacy/index.vue"),
        meta: {
          sidebar: false,
          i18nTitle: "settings.privacy_title",
        },
      },
      ...help,
    ],
  },
] as RouteRecordRaw[];
